<template>
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <column-chart :data="data" :download="true" />
      </v-card-text>
    </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    data: Array,
  },
}
</script>

<style>

</style>
